import { render } from "./Service.vue?vue&type=template&id=1340bd70&scoped=true"
const script = {}

import "./Service.vue?vue&type=style&index=0&id=1340bd70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1340bd70"

export default script